import {
    bootstrapsKeyword,
    getFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'

import { getErrorMessage } from '@/shared/lib'
import { request } from '@/api/apiClient'
import { Profile, ProfileStreamIQ } from '@/shared/store/useAppStore'
import { ILoginAndProfileService } from '@/shared/types/services/types/loginAndProfile/loginAndProfileTypes'
import {
    getBootstraps,
    mapProfileStreamIQToProfile,
} from '@/clients/streamiq/shared/lib'
import { LAST_ACTUAL_PROFILE } from '@/shared/constants'

class LoginAndProfileServiceStreamIQ implements ILoginAndProfileService {
    fetchProfiles = async () => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        const bootstraps = getBootstraps()

        const profileId = getFromLocalStorage(LAST_ACTUAL_PROFILE)
        try {
            const { jsonData: response } = await request(
                'GET',
                bootstraps?.services?.['crm-service'].profile || '',
                sessionToken,
                false,
                undefined,
                undefined,
                {
                    'User-Profile-Id': profileId ? profileId : 1,
                }
            )

            if (response) {
                return response.resources.map((item: ProfileStreamIQ) =>
                    mapProfileStreamIQToProfile(item)
                )
            } else {
                throw new Error('Invalid response format')
            }
        } catch (error) {
            getErrorMessage('Error fetching profiles:', error)
            throw error
        }
    }

    checkPin = async (pin: number, id: string) => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        const bootstrapsObject = getFromLocalStorage(bootstrapsKeyword)

        if (!bootstrapsObject) return

        const bootstraps = JSON.parse(bootstrapsObject)
        const route = `${bootstraps?.services?.['crm-service'].profile}/${id}`
        try {
            const { jsonData: response } = await request(
                'GET',
                route,
                sessionToken,
                false
            )

            if (response.pin === pin) {
                return true
            } else return false
        } catch (error) {
            getErrorMessage('Error check pin:', error)
            throw error
        }
    }

    setProfile = async (profile: {
        version: number
        profile_name: string
        isKid: boolean
        order: string
        iconId: string
    }) => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        const bootstraps = getBootstraps()

        try {
            await request(
                'POST',
                bootstraps?.services?.['crm-service'].profile,
                sessionToken,
                false,
                JSON.stringify({
                    isAdult: profile.isKid,
                    name: profile.profile_name,
                    pin: Number('0000'),
                })
            )
        } catch (error) {
            getErrorMessage('Error set profiles:', error)
            throw error
        }
    }

    deleteProfile = async (id: string) => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        const bootstraps = getBootstraps()

        const route = `${bootstraps?.services?.['crm-service'].profile}/${id}`
        try {
            await request('DELETE', route, sessionToken, false)
        } catch (error) {
            getErrorMessage('Error delete profiles:', error)
            throw error
        }
    }

    updateProfile = async (profile: Profile) => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        const bootstraps = getBootstraps()

        const route = `${bootstraps?.services?.['crm-service'].profile}/${profile.id}`

        try {
            const response = await request(
                'PATCH',
                route,
                sessionToken,
                false,
                JSON.stringify({
                    isAdult: profile.isKid,
                    name: profile.profile_name,
                    pin: Number('0000'),
                })
            )
            if (response) {
                return true
            } else {
                throw new Error('Invalid response format')
            }
        } catch (error) {
            getErrorMessage('Error update profiles:', error)
            throw error
        }
    }
}

export default new LoginAndProfileServiceStreamIQ()
